import {useEffect, FunctionComponent, ReactElement} from 'react';
import reportError from '../reportError';

type Props = {
    /** name of error report */
    name: string;
    children?: ReactElement;
};

/**
 * Reports an error and renders any children.
 */
const ErrorReport: FunctionComponent<Props> = ({name, children}: Props) => {
    useEffect(() => {
        reportError({name});
    }, [name]);
    return children || null;
};

export default ErrorReport;
